import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

const day = dayjs.extend(customParseFormat);

export default day;
